import { FieldName } from "./query-component";
import { AppEvents } from "./../../app-events";
import { prop } from "../../decorators/property";

export class AdvancedSearchFieldHelpModel extends Backbone.AssociatedModel {

    @prop() public Examples: string[];
    @prop() public TipHtml: string;
    @prop() public DescriptionHtml: string;

    @prop() public Available: boolean = this.IsHelpAvailable();
    @prop() public HasExamples: boolean = this.hasExamples();

    private appEvents: Backbone.Events;

    private IsHelpAvailable(): boolean {
        return this.hasExamples() || this.hasTip() || this.hasDescription();
    }

    private hasTip(): boolean {
        return this.TipHtml && this.TipHtml.length > 0;
    }

    private hasDescription(): boolean {
        return this.DescriptionHtml && this.DescriptionHtml.length > 0;
    }

    private hasExamples(): boolean {
        return this.Examples && this.Examples.length > 0;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/advanced-search-field-help.ts